<template>
  <!-- 任务列表弹窗：左栏与街道右下角快捷条共用（2026-10-02 从 streetleft 抽出） -->
  <el-dialog class="wrap" :visible.sync="innerVisible" :before-close="close" :modal-append-to-body="false">
    <div class="taskbg">
        <div class="tasktitle">
            任务列表（<span @click="showTitle('当前随机任务数/今日已接随机任务数/随机任务数上限（链任务不计数）')" title="当前随机任务数/今日已接随机任务数/随机任务数上限（链任务不计数）">{{randomTodoCount}}/{{taskCount}}/{{taskMax}}</span>）
        </div>
        <div v-if="null != taskListDisplay" class="tasklist">
            <el-row>
            <el-col :span="5"><span>任务名称</span></el-col>
            <el-col :span="4"><span>发布人</span></el-col>
            <el-col :span="4"><span>接收人</span></el-col>
            <el-col :span="5"><span>任务目标</span></el-col>
            <el-col :span="6"><span>接受时间</span></el-col>
            </el-row>
            <div v-for="fantasyTaskTodoBO in taskListDisplay" v-bind:key="fantasyTaskTodoBO.id" :id="fantasyTaskTodoBO.id + '_task'">
            <el-row>
                <el-col :span="5"><span @click="showTitle(fantasyTaskTodoBO.taskDesc)">{{fantasyTaskTodoBO.taskName}}</span><span v-if="fantasyTaskTodoBO.ring" class="ring-badge">{{fantasyTaskTodoBO.ring}}/{{ringMax}}</span></el-col>
                <el-col :span="4"><span class="npc-link" @click="locateNpc(fantasyTaskTodoBO.taskFrom)">{{fantasyTaskTodoBO.taskFrom}}</span></el-col>
                <el-col :span="4"><span class="npc-link" @click="locateNpc(fantasyTaskTodoBO.taskTo)">{{fantasyTaskTodoBO.taskTo}}</span></el-col>
                <el-col :span="5">
                  <span @click="showTitle(fantasyTaskTodoBO.taskDesc)" v-if="fantasyTaskTodoBO.itemScore>-1">{{fantasyTaskTodoBO.taskItem}}
                    <span v-if="fantasyTaskTodoBO.itemScore!=null">(<span style="color:red;">{{fantasyTaskTodoBO.itemScore}}分以上</span>)</span>
                    <span v-if="fantasyTaskTodoBO.scoreBonusMoney>0" style="color:#e6a23c;" title="交付评分达标的制造品才有">额外+{{fantasyTaskTodoBO.scoreBonusMoney}}元</span>
                  </span>
                  <span @click="showTitle(fantasyTaskTodoBO.taskDesc)" v-else>{{fantasyTaskTodoBO.taskItem}}</span>
                </el-col>
                <el-col :span="6"><span>{{shortTime(fantasyTaskTodoBO.startTime)}}</span></el-col>
            </el-row>
            </div>
        </div>
        <div class="noTask" v-if="null == taskListDisplay">
            未查询到任务列表
        </div>
        <div style="clear:both"></div>
    </div>
  </el-dialog>
</template>
<script>
import {getRequest, postRequest} from '../../utils/api'
import Message from 'element-ui/lib/message'
import {mapState} from 'vuex'
export default {
  name: 'taskListDialog',
  data() {
    return {
      innerVisible: false,
      taskCount: 0,
      taskMax: 0,
      ringMax: 10
    };
  },
  computed: {
    ...mapState('street', ['fantasyTaskTodoBOList', 'taskListDisplay', 'cityMap']),
    // 计数随机口径（2026-10-01 用户定版）：链任务不计数，三联数字只反映随机任务
    randomTodoCount() {
      return (this.fantasyTaskTodoBOList || []).filter(t => Number(t.taskIsRand) === 1).length;
    }
  },
  methods: {
    open() {
      this.innerVisible = true;
      this.fetchTaskList();
    },
    close() {
      this.innerVisible = false;
    },
    showTitle(value) {
      this.$notify({ message: value, duration: 6000 });
    },
    // 任务列表列窄，时间去掉年份，只显示 MM-DD HH:mm
    shortTime: function(value) {
      if (!value) return '';
      const d = new Date(value);
      if (isNaN(d.getTime())) return '';
      const p = function(n) { return n < 10 ? '0' + n : '' + n; };
      return p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' '
        + p(d.getHours()) + ':' + p(d.getMinutes());
    },
    fetchTaskList: function() {
      var _this = this;
      getRequest('/task/task/getTaskList', {}).then(resp=> {
        if (resp.status == 200) {
          var respData = resp.data;
          if (200 == respData.status) {
            this.$store.commit('street/SET_TASK_LIST_DISPLAY', respData.data.fantasyTaskTodoBOList || []);
            this.taskCount = respData.data.taskCount;
            this.taskMax = respData.data.taskMax;
            this.ringMax = respData.data.ringMax || 10;
          } else { this.$store.commit('street/SET_TASK_LIST_DISPLAY', []); Message.error(respData.message); }
        } else { Message.error('用户非法⊙﹏⊙∥!'); }
      }, resp=> { Message.error('用户非法⊙﹏⊙∥!222'); });
    },
    // 任务列表点击 NPC：当前节点滚动高亮定位，其他节点通知所在位置
    locateNpc: function(npcName) {
      const _this = this;
      if (npcName == null || npcName === '' || npcName === '无') return;
      postRequest('/npc/npc/queryNpc', { npcName: npcName, page: 1 }).then(resp=> {
        if (resp.status == 200 && resp.data != null && resp.data.list != null && resp.data.list.length > 0) {
          const npc = resp.data.list[0];
          // 当前节点：关闭任务列表弹窗与移动端菜单抽屉，滚动到 NPC 头像并高亮
          if (npc.mapId != null && npc.mapId == _this.cityMap.id) {
            _this.close();
            _this.$root.eventHub.$emit('closeDrawer');
            _this.$nextTick(() => {
              const el = document.getElementById('npc_' + npc.npcId);
              if (!el) { _this.showTitle(npc.npcName + ' 位于：' + (npc.cityname || '') + '·' + (npc.placename || '')); return; }
              el.scrollIntoView({ behavior: 'smooth', block: 'center' });
              const img = el.querySelector('img');
              if (img) {
                img.style.outline = '3px solid #ff9d00';
                img.style.outlineOffset = '2px';
                img.style.borderRadius = '4px';
                setTimeout(() => { img.style.outline = ''; img.style.outlineOffset = ''; }, 2500);
              }
            });
          } else {
            _this.showTitle(npc.npcName + ' 位于：' + (npc.cityname || '') + '·' + (npc.placename || ''));
          }
        } else {
          _this.showTitle('未找到 ' + npcName + ' 的位置');
        }
      }, resp=> {
        Message.error('用户非法⊙﹏⊙∥!');
      });
    },
  }
}
</script>

<style scoped>
.taskbg { width: 100%; height: 400px; }
/* 环任务标记：第 N/10 环（浅色小胶囊，不抢任务名的位置） */
.ring-badge {
  display: inline-block;
  margin-left: 4px;
  padding: 0 4px;
  font-size: 10px;
  line-height: 15px;
  color: #e6a23c;
  background: #fdf6ec;
  border: 1px solid #f5dab1;
  border-radius: 7px;
  vertical-align: middle;
  white-space: nowrap;
}
.taskbg .tasktitle {
  padding: 6px 10px;
  background-color: #67c23a;
  font-size: 15px;
  font-weight: bold;
  color: #fff;
  letter-spacing: 3px;
  text-align: center;
  border-radius: 4px;
}
.taskbg .tasklist { padding: 5px; text-align: center; }
.taskbg .notask { padding: 3px 5px; font-size: 16px; font-weight: bold; letter-spacing: 5px; text-align: center; height: 100px; line-height: 100px; }
.tasklist .el-row { font-size: 14px; }
.tasklist .el-col span { height: 40px; line-height: 40px; }
.tasklist .npc-link { cursor: pointer; color: #7ec8ff; text-decoration: underline; }
.taskbg .tasktitle span { cursor: pointer; color: #e6f7ff; }

/* ========== 移动端任务弹窗适配 ========== */
@media (max-width: 768px) {
  .taskbg {
    height: auto;
    max-height: 60vh;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .taskbg .tasktitle {
    font-size: 13px;
    padding: 5px 8px;
    letter-spacing: 1px;
  }
  .tasklist { overflow-x: hidden; }
  .tasklist .el-row { font-size: 12px; min-width: 0; }
  .tasklist .el-col {
    min-width: 0;
    padding: 0 2px !important;
  }
  .tasklist .el-col span {
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }
  .taskbg .notask { font-size: 13px; letter-spacing: 2px; height: 80px; line-height: 80px; }
}
</style>
